import SEO from "@/components/SEO";
import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

export default function ContatoPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contato | GodoyProd",
      url: `${siteUrl}/contato`,
      description: "Entre em contato com a GodoyProd para solicitar transcrições de partituras, tirar dúvidas ou enviar sugestões.",
      inLanguage: "pt-BR",
      mainEntity: {
        "@type": "Organization",
        name: "GodoyProd",
        url: siteUrl,
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+55-15-99181-1212",
          contactType: "customer service",
          availableLanguage: ["Portuguese"],
          email: "contato@godoyprod.com",
        },
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "GodoyProd",
      url: siteUrl,
      logo: "https://pub-bc092def332d4fb180f02b510802da8e.r2.dev/LogoGP.png",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+55-15-99181-1212",
        contactType: "customer service",
        availableLanguage: ["Portuguese"],
        email: "contato@godoyprod.com",
      },
      sameAs: [
        "https://www.instagram.com/eugoodoy",
        "https://www.youtube.com/@GodoyProd",
        "https://open.spotify.com/user/eugoodoy?si=8d3a4aea30714493",
      ],
    },
  ];

  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    instagram: "",
    tipo: "transcrição",
    artista: "",
    musica: "",
    mensagem: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const texto = `Ola! Meu nome e ${formData.nome}.%0A%0A` +
      `Tipo de solicitação: ${formData.tipo === "transcrição" ? "Transcricao especifica" : "Outro assunto"}%0A%0A` +
      (formData.instagram ? `Instagram: ${formData.instagram}%0A` : "") +
      (formData.artista ? `Artista: ${formData.artista}%0A` : "") +
      (formData.musica ? `Musica: ${formData.musica}%0A%0A` : "") +
      `Mensagem: ${formData.mensagem}%0A%0A` +
      `Email: ${formData.email}`;

    window.open(`https://wa.me/5515991811212?text=${texto}`, "_blank");
  };

  return (
    <>
      <SEO
        title="Contato"
        description="Entre em contato com a GodoyProd. Solicite transcrições de partituras, tire dúvidas ou envie sugestões. Atendimento via WhatsApp em até 24 horas."
        keywords="contato GodoyProd, solicitar transcrição, transcrição partituras, suporte, WhatsApp"
        schema={schema}
        canonicalPath="/contato"
      />
      <div className="min-h-screen bg-godoy-black">
        <Navbar />

        <section className="pt-32 pb-20 md:pt-40 md:pb-28">
          <div className="w-full px-6 md:px-10 lg:px-16 max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <span className="text-godoy-gold text-sm font-semibold tracking-widest uppercase">
                Contato
              </span>
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-godoy-cream mt-4">
                Entre em Contato
              </h1>
              <p className="text-godoy-lightgray mt-4 max-w-2xl mx-auto">
                Solicite uma transcrição específica, tire dúvidas ou envie sugestões.
                Estamos prontos para atender você.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
              {/* Info */}
              <div className="lg:col-span-2 space-y-8">
                <div>
                  <h3 className="font-serif text-xl font-semibold text-godoy-cream mb-4">
                    Informações de Contato
                  </h3>
                  <div className="space-y-4">
                    <a
                      href="mailto:contato@godoyprod.com"
                      className="flex items-center gap-3 text-godoy-lightgray hover:text-godoy-gold transition-colors group"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray group-hover:bg-godoy-gold/20 transition-all">
                        <i className="ri-mail-line text-godoy-gold" />
                      </div>
                      <span className="text-sm">contato@godoyprod.com</span>
                    </a>
                    <a
                      href="https://wa.me/5515991811212"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-godoy-lightgray hover:text-godoy-gold transition-colors group"
                    >
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray group-hover:bg-godoy-gold/20 transition-all">
                        <i className="ri-whatsapp-line text-godoy-gold" />
                      </div>
                      <span className="text-sm">(15) 9 9181-1212</span>
                    </a>
                  </div>
                </div>

                <div>
                  <h3 className="font-serif text-xl font-semibold text-godoy-cream mb-4">
                    Redes Sociais
                  </h3>
                  <div className="flex gap-3">
                    <a
                      href="https://open.spotify.com/user/eugoodoy?si=8d3a4aea30714493"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
                    >
                      <i className="ri-spotify-fill text-lg" />
                    </a>
                    <a
                      href="https://www.instagram.com/eugoodoy"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
                    >
                      <i className="ri-instagram-fill text-lg" />
                    </a>
                    <a
                      href="https://www.youtube.com/@GodoyProd"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-godoy-gray hover:bg-godoy-gold/20 text-godoy-cream hover:text-godoy-gold transition-all"
                    >
                      <i className="ri-youtube-fill text-lg" />
                    </a>
                  </div>
                </div>

                <div className="bg-godoy-charcoal/60 border border-godoy-gray/30 rounded-lg p-6">
                  <h4 className="font-serif text-lg font-semibold text-godoy-cream mb-2">
                    Resposta Rápida
                  </h4>
                  <p className="text-godoy-lightgray text-sm">
                    Respondemos todas as mensagens em até 24 horas. Para solicitações
                    urgentes, prefira o WhatsApp.
                  </p>
                </div>
              </div>

              {/* Form */}
              <div className="lg:col-span-3">
                <form
                  onSubmit={handleSubmit}
                  className="bg-godoy-charcoal/60 border border-godoy-gray/30 rounded-lg p-6 md:p-8 space-y-5"
                >
                  <h3 className="font-serif text-xl font-semibold text-godoy-cream mb-4">
                    Solicitar Transcrição
                  </h3>

                  <div>
                    <label className="block text-sm text-godoy-lightgray mb-1.5">
                      Nome completo
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.nome}
                      onChange={(e) =>
                        setFormData({ ...formData, nome: e.target.value })
                      }
                      className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm"
                      placeholder="Seu nome"
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-godoy-lightgray mb-1.5">
                      Email
                    </label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm"
                      placeholder="seu@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm text-godoy-lightgray mb-1.5">
                      Instagram (opcional)
                    </label>
                    <input
                      type="url"
                      value={formData.instagram}
                      onChange={(e) =>
                        setFormData({ ...formData, instagram: e.target.value })
                      }
                      className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm"
                      placeholder="https://instagram.com/seuusuario"
                    />
                    <p className="text-xs text-godoy-lightgray/50 mt-1">
                      Cole o link completo do seu perfil no Instagram.
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm text-godoy-lightgray mb-1.5">
                      Tipo de solicitação
                    </label>
                    <select
                      value={formData.tipo}
                      onChange={(e) =>
                        setFormData({ ...formData, tipo: e.target.value })
                      }
                      className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream focus:outline-none focus:border-godoy-gold/50 text-sm"
                    >
                      <option value="transcricao">Transcrição específica</option>
                      <option value="duvida">Dúvida sobre partituras</option>
                      <option value="sugestao">Sugestão de música</option>
                      <option value="outro">Outro assunto</option>
                    </select>
                  </div>

                  {formData.tipo === "transcricao" && (
                    <>
                      <div>
                        <label className="block text-sm text-godoy-lightgray mb-1.5">
                          Artista
                        </label>
                        <input
                          type="text"
                          value={formData.artista}
                          onChange={(e) =>
                            setFormData({ ...formData, artista: e.target.value })
                          }
                          className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm"
                          placeholder="Nome do artista"
                        />
                      </div>
                      <div>
                        <label className="block text-sm text-godoy-lightgray mb-1.5">
                          Nome da música
                        </label>
                        <input
                          type="text"
                          value={formData.musica}
                          onChange={(e) =>
                            setFormData({ ...formData, musica: e.target.value })
                          }
                          className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm"
                          placeholder="Título da música"
                        />
                      </div>
                    </>
                  )}

                  <div>
                    <label className="block text-sm text-godoy-lightgray mb-1.5">
                      Mensagem
                    </label>
                    <textarea
                      required
                      rows={4}
                      maxLength={500}
                      value={formData.mensagem}
                      onChange={(e) =>
                        setFormData({ ...formData, mensagem: e.target.value })
                      }
                      className="w-full px-4 py-2.5 bg-godoy-black/60 border border-godoy-gray/30 rounded-md text-godoy-cream placeholder:text-godoy-lightgray/40 focus:outline-none focus:border-godoy-gold/50 text-sm resize-none"
                      placeholder="Descreva sua solicitação em detalhes..."
                    />
                    <p className="text-xs text-godoy-lightgray/50 mt-1 text-right">
                      {formData.mensagem.length}/500
                    </p>
                  </div>

                  <button
                    type="submit"
                    className="w-full py-3 bg-godoy-gold text-godoy-black font-semibold rounded-md hover:bg-godoy-goldlight transition-all text-sm flex items-center justify-center gap-2"
                  >
                    <i className="ri-whatsapp-line" />
                    Enviar via WhatsApp
                  </button>

                  <p className="text-xs text-godoy-lightgray/60 text-center">
                    Ao clicar em enviar, você será direcionado para o WhatsApp
                    com a mensagem preenchida.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}